import React from 'react';
import Layout from '../../components/Shared/Layout';
import AudioCardio from '../../components/Portfolio/audio-cardio';
import '../../assets/css/bbqguru.css';
import * as ReactGA from 'react-ga';

const $ = typeof window !== `undefined` ? require('jquery') : null;

class AudioCardioPage extends React.Component {
  /* constructor(props) {
      super(props);
  } */
  componentDidMount() {
    ReactGA.set({
      title: 'Portfolio/bbqguru',
    });
    ReactGA.pageview(this.props.location.pathname);
  }

  render() {
    return (
      <Layout>
        <AudioCardio />
      </Layout>
    );
  }
}

export default AudioCardioPage;
